import { useEffect, useState } from 'react';

import countries from '@/shared/configs/countries.json';
import Customer from '@/shared/types/customer.type';

type Args = {
  customer: Customer | null;
};

const useBillingAddressForm = ({ customer }: Args) => {
  const [billingAddressFormFields, setBillingAddressFormFields] = useState<
    Partial<Customer>
  >({
    billing_address: '',
    billing_address2: '',
    billing_city: '',
    billing_country: '',
    billing_state: '',
    billing_postcode: '',
  });

  const onUpdateBillingAddress = (values: Record<string, unknown>) => {
    setBillingAddressFormFields((prev) => {
      if (values.billing_country) {
        const country = countries.find(
          (country) => country.code === values.billing_country,
        );
        values.billing_state = country?.provinces[0].code;
      }

      return { ...prev, ...values };
    });
  };

  useEffect(() => {
    if (customer) {
      setBillingAddressFormFields({
        billing_address: customer.billing_address,
        billing_address2: customer.billing_address2,
        billing_city: customer.billing_city,
        billing_country: customer.billing_country,
        billing_state: customer.billing_state,
        billing_address_type: customer.billing_address_type,
        billing_postcode: customer.billing_postcode,
      });
    }
  }, [customer]);

  return {
    billingAddressFormFields,
    onUpdateBillingAddress,
  };
};

export default useBillingAddressForm;
